import { render, staticRenderFns } from "./MediaUnitEditor.vue?vue&type=template&id=39ecb285&scoped=true&"
import script from "./MediaUnitEditor.vue?vue&type=script&lang=js&"
export * from "./MediaUnitEditor.vue?vue&type=script&lang=js&"
import style0 from "./MediaUnitEditor.vue?vue&type=style&index=0&id=39ecb285&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ecb285",
  null
  
)

export default component.exports